<template>
    {{t("tiles.messages.errorNoUnihubPermission")}}
</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import { useI18n } from 'vue-i18n';

    export default defineComponent({
        setup() {
            const { t } = useI18n();
            return {
                t
            };
        }
    })

</script>

<style lang="scss" scoped>
    :deep(.p-dialog) {
        max-width: 75vw;
    }
</style>